import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-8 relative" }
const _hoisted_2 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_3 = { class: "h-5 w-5 me-2" }
const _hoisted_4 = { class: "mt-6 text-center" }
const _hoisted_5 = { class: "text-lg font-semibold leading-6 text-gray-900" }
const _hoisted_6 = { class: "mt-6 text-center" }
const _hoisted_7 = { class: "text-sm text-gray-600" }
const _hoisted_8 = { class: "mt-6 flex justify-around items-center gap-3" }
const _hoisted_9 = { class: "text-center mt-2" }
const _hoisted_10 = { class: "text-sm text-gray-600" }
const _hoisted_11 = { class: "p-8 relative" }
const _hoisted_12 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_13 = { class: "mt-6 text-center" }
const _hoisted_14 = { class: "text-lg font-semibold leading-6 text-gray-900" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "mt-6 text-center" }
const _hoisted_18 = { class: "text-sm text-gray-600" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "mt-6 flex justify-around items-center gap-3" }
const _hoisted_22 = { class: "text-center mt-2" }
const _hoisted_23 = { class: "text-sm text-gray-600" }
const _hoisted_24 = { class: "p-8 relative" }
const _hoisted_25 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_26 = { class: "mt-6 text-center" }
const _hoisted_27 = { class: "text-lg font-semibold leading-6 text-gray-900" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-sm text-gray-600" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteRolloverModals',
  props: {
    confirmRolloverDateModal: { type: Boolean },
    completeRolloverModal: { type: Boolean }
  },
  emits: ["update:confirmRolloverDateModal", "update:completeRolloverModal"],
  setup(__props: any, { emit }) {

const props = __props;





const rolloverStore = useRolloverStore();
const router = useRouter();

const rolloverDate = ref("2024-01-01");
const newRolloverDate = ref("");
const isCalendarHidden = ref(false);

const confirmDates = async () => {
  emit("update:confirmRolloverDateModal", false);

  const currentRollOver = rolloverStore.rollover as Rollover;

  if (newRolloverDate.value) {
    rolloverDate.value = newRolloverDate.value;
    currentRollOver.rolloverDate = new Date(newRolloverDate.value).toISOString();
  }

  currentRollOver.status.learnerRollover = "in_review";
  await rolloverStore.updateRolloverObject(currentRollOver);

  router.push("/main/incomplete-rollover");
};

const confirmRolloverComplete = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;
  currentRollOver.isComplete = true;
  await rolloverStore.updateRolloverObject(currentRollOver);

  emit("update:completeRolloverModal", false);
  router.push("/main/internal");
};

const confirmClassReview = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.status.classReview = "pending_job_run";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  // completeClassReviewModal.value = false;
  router.push("/main/internal");
};

return (_ctx: any,_cache: any) => {
  const _component_rl_ico = _resolveComponent("rl-ico")!
  const _component_modal = _resolveComponent("modal")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: _ctx.confirmRolloverDateModal,
      onLocalModalOpen: _cache[3] || (_cache[3] = (val) => emit('update:confirmRolloverDateModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_rl_ico, {
                  icon: 'rl-rollover-red-calender',
                  title: 'rl rollover red calender',
                  "aria-hidden": "true"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.title")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")) + " " + _toDisplayString(_ctx.$t("rollover.modal.confirm_date.starting")) + " " + _toDisplayString(rolloverDate.value) + ".", 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.text")) + ". ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "whitespace-nowrap font-medium rounded-lg w-full py-2 px-6 btn-outline-red text-red-300 border border-red-300",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:confirmRolloverDateModal', false)))
            }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.change")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "whitespace-nowrap font-medium py-2 px-6 btn-red bg-red-300 text-white rounded-lg w-full",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:confirmRolloverDateModal', false)))
            }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.date_correct")), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.not_ready")) + "? ", 1),
              _createElementVNode("span", {
                class: "text-red-300",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:confirmRolloverDateModal', false)))
              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_later")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: _ctx.confirmRolloverDateModal,
      onLocalModalOpen: _cache[10] || (_cache[10] = (val) => emit('update:confirmRolloverDateModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-rollover-red-calender',
                title: 'rl rollover red calender',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h3", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.title")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")) + " " + _toDisplayString(_ctx.$t("rollover.modal.confirm_date.starting")) + " ", 1),
                (newRolloverDate.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(newRolloverDate.value), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(rolloverDate.value), 1)),
                _createTextVNode(". ")
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.text")) + ". ", 1)
            ])
          ]),
          (isCalendarHidden.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("pre", _hoisted_20, _toDisplayString(_unref(rolloverStore).rollover?.rolloverDate) + " ", 1),
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FormKit, {
                      type: "date",
                      label: "Select new date",
                      "label-class": "text-gray-700 font-medium text-sm mb-1.5",
                      "outer-class": "primary-select label-bold mt-6",
                      modelValue: newRolloverDate.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newRolloverDate).value = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            (!isCalendarHidden.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "whitespace-nowrap font-medium rounded-lg w-full py-2 px-6 btn-outline-red text-red-300 border border-red-300",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (isCalendarHidden.value = true))
                }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.change")), 1))
              : _createCommentVNode("", true),
            (!isCalendarHidden.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmDates())),
                  type: "button",
                  class: "whitespace-nowrap rounded-lg w-full font-medium py-2 px-6 btn-red bg-red-300 text-white"
                }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.date_correct")), 1))
              : _createCommentVNode("", true),
            (isCalendarHidden.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "whitespace-nowrap font-medium py-2 px-6 btn-outline-red text-red-300 border border-red-300",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (isCalendarHidden.value = false))
                }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.cancel")), 1))
              : _createCommentVNode("", true),
            (isCalendarHidden.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (confirmDates())),
                  type: "button",
                  class: "whitespace-nowrap font-medium py-2 px-6 btn-red bg-red-300 text-white"
                }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_dates")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", _hoisted_23, [
              _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.not_ready")) + "? ", 1),
              _createElementVNode("span", {
                class: "text-red-300",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (confirmDates()))
              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_later")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: _ctx.completeRolloverModal,
      onLocalModalOpen: _cache[13] || (_cache[13] = (val) => emit('update:completeRolloverModal', val))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (emit('update:completeRolloverModal', false))),
              class: "absolute top-4 right-4 focus-within:outline-none"
            }, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-small-close',
                title: 'rl small close',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-rollover-mail',
                title: 'rl rollover mail',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.$t("rollover.modal.success.title")), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("rollover.modal.success.text")), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (confirmRolloverComplete())),
              type: "button",
              class: "bg-blue-600 rounded-lg p-2.5 text-base shadow-lg text-white mt-6 flex flex-row justify-center items-center flex-wrap mx-auto"
            }, _toDisplayString(_ctx.$t("rollover.modal.success.confirm")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})